export const ConstantsTypesMap = {
  FEATURE_TOGGLE: 'featureToggle'
};

export const EnvsNamesMap = {
  STAGE: 'stage',
  MASTER: 'play',
  PROD: 'prod'
};

export const SessionsTypesMap = {
  DEFAULT: 'DEFAULT',
  RHAPSODY_ENTERPRISE: 'RHAPSODY_ENTERPRISE'
};

export const SESSION_PROCESSED_DIRECTORY = 'universal';

export const SessionStatusesMap = {
  EXPORTER_DOWNLOADED: 'EXPORTER_DOWNLOADED',
  DATA_IS_READY: 'DATA_IS_READY',
  ANALYSIS_IN_PROGRESS: 'ANALYSIS_IN_PROGRESS',
  ANALYSIS_DONE: 'ANALYSIS_DONE',
  REVIEW_EXCEPTIONS: 'REVIEW_EXCEPTIONS',
  IMPORT_IS_READY: 'IMPORT_IS_READY',
  CONFIRM_IMPORT_SETTINGS: 'CONFIRM_IMPORT_SETTINGS',
  IMPORT_IN_PROGRESS: 'IMPORT_IN_PROGRESS',
  IMPORT_DONE: 'IMPORT_DONE',
  STOPPED: 'STOPPED',
  EXPORT_DONE: 'EXPORT_DONE',
  PREPROCESSING_IN_PROGRESS: 'PREPROCESSING_IN_PROGRESS',
  PREPROCESSING_DONE: 'PREPROCESSING_DONE',
  PREPROCESSING_FAILED: 'PREPROCESSING_FAILED'
};

export const PreprocessorStartStatusesList = [
  SessionStatusesMap.EXPORT_DONE,
  SessionStatusesMap.PREPROCESSING_DONE,
  SessionStatusesMap.PREPROCESSING_FAILED
];

export const InventoryItemsAvailableStatusesList = [
  SessionStatusesMap.EXPORT_DONE,
  SessionStatusesMap.PREPROCESSING_DONE
];

export const PortalPracticesLinksMap = {
  [EnvsNamesMap.STAGE]:
    'https://portal.stage.rhapsody.vet/admin/general/practices/',
  [EnvsNamesMap.MASTER]:
    'https://portal.master.rhapsody.vet/admin/general/practices/',
  [EnvsNamesMap.PROD]: 'https://portal.rhapsody.vet/admin/general/practices/'
};
